import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { REALTIME_NOTIFICATION_LOG_MODULE } from '../../../../shared/constants';
import { logError } from '../../../../../shared/logError';
import { JobPost } from '../types';

export const snoozeAgenticBriefMatch = async (jobPost: JobPost) => {
    try {
        if (!jobPost.jobPostId) {
            throw new Error('Missing jobPostId');
        }

        await axios.post(pathfinder('snooze_agentic_brief_match', { brief_id: jobPost.jobPostId }), {
            minutes: jobPost.snoozeDurationMinutes,
        });
    } catch (error) {
        logError(error, {
            module: REALTIME_NOTIFICATION_LOG_MODULE,
            payload: { action: 'snoozeAgenticBriefMatch', jobPostId: jobPost.jobPostId },
        });
    }
};
